import { groupsDao } from '../dao/groups-dao'
import type {
  AdminGroupMembersListResponse,
  AdminGroupPostsListResponse,
  AdminGroupsListResponse,
  CreateGroupPayload,
  CreateGroupPostInput,
  DiscoverGroupsParams,
  Group,
  GroupMember,
  GroupMemberResponse,
  GroupMemberRole,
  GroupPost,
  GroupPostsListResponse,
  UpdateGroupPayload,
} from '../types/groups'

export const groupsService = {
  discoverGroups: (
    params?: DiscoverGroupsParams,
  ): Promise<{ data: (Group & { isJoined: boolean })[]; meta: { limit: number; offset: number; total: number } }> =>
    groupsDao.discoverGroups(params),
  myGroups: (): Promise<Group[]> => groupsDao.myGroups(),
  getGroupById: (groupId: string): Promise<Group> => groupsDao.getGroupById(groupId),
  joinGroupByCode: (inviteCode: string): Promise<GroupMemberResponse> => groupsDao.joinByInviteCode(inviteCode),
  joinPublicGroup: (groupId: string): Promise<GroupMemberResponse> => groupsDao.joinPublicGroup(groupId),
  leaveGroup: (groupId: string): Promise<void> => groupsDao.leaveGroup(groupId),
  listMembers: (groupId: string, params?: { limit?: number; offset?: number }): Promise<GroupMember[]> =>
    groupsDao.listMembers(groupId, params),
  inviteMembers: (groupId: string, hustlerIds: string[]): Promise<void> => groupsDao.inviteMembers(groupId, hustlerIds),
  changeMemberRole: (groupId: string, memberId: string, role: GroupMemberRole): Promise<void> =>
    groupsDao.changeMemberRole(groupId, memberId, role),
  removeMember: (groupId: string, memberId: string): Promise<void> => groupsDao.removeMember(groupId, memberId),
  updateGroup: (groupId: string, data: UpdateGroupPayload): Promise<Group> => groupsDao.updateGroup(groupId, data),
  deleteGroup: (groupId: string): Promise<void> => groupsDao.deleteGroup(groupId),
  regenerateInviteCode: (groupId: string): Promise<Group> => groupsDao.regenerateInviteCode(groupId),
  getGroupPosts: (groupId: string, params?: { limit?: number; offset?: number }): Promise<GroupPostsListResponse> =>
    groupsDao.listGroupPosts(groupId, params),
  createGroupPost: (groupId: string, data: CreateGroupPostInput): Promise<GroupPost> => groupsDao.createGroupPost(groupId, data),
  deleteGroupPost: (groupId: string, postId: string): Promise<void> => groupsDao.deleteGroupPost(groupId, postId),
  togglePinPost: (groupId: string, postId: string): Promise<void> => groupsDao.togglePinPost(groupId, postId),

  // Admin methods
  adminListGroups: (params: { limit: number; offset: number; search?: string }): Promise<AdminGroupsListResponse> =>
    groupsDao.adminListGroups(params),
  adminCreateGroup: (data: CreateGroupPayload): Promise<Group> => groupsDao.adminCreateGroup(data),
  adminGetGroup: (groupId: string): Promise<Group> => groupsDao.adminGetGroup(groupId),
  adminUpdateGroup: (groupId: string, data: UpdateGroupPayload): Promise<Group> => groupsDao.adminUpdateGroup(groupId, data),
  adminDeleteGroup: (groupId: string): Promise<void> => groupsDao.adminDeleteGroup(groupId),
  adminListMembers: (groupId: string, params: { limit: number; offset: number }): Promise<AdminGroupMembersListResponse> =>
    groupsDao.adminListMembers(groupId, params),
  adminAddMembers: (groupId: string, hustlerIds: string[]): Promise<void> => groupsDao.adminAddMembers(groupId, hustlerIds),
  adminRemoveMember: (groupId: string, memberId: string): Promise<void> => groupsDao.adminRemoveMember(groupId, memberId),
  adminListPosts: (groupId: string, params: { limit: number; offset: number }): Promise<AdminGroupPostsListResponse> =>
    groupsDao.adminListPosts(groupId, params),
}
